import axios from "axios";
import axiosInstance from "./axiosInstance";
import toast from "react-hot-toast";
import queryString from "query-string"
const userService = {
  checkUser,
  registerUser,
  loginUser,
  getSauceToken,
  getEventList,
  forgotPassword,
  changeUserPassword,
  saveUserPreference,
  getOrders,
  generateQrCode,
  getSearch,
  getPreference,
  getPrintBadge,
  sendZPLFileToPrint,
  fetchTenantId,
  getUserData,
  createEventBadge,
  geEventBadge,
  getZlpImage,
  getEventQuestions,
  getTicketDetail,
  getOrderDetail, getTicketQuestions,
  getPrinterList,
  fetchPrinterList,
  updateDefaultPrinter,
  createBadgePrintLog,
  getAllBadgePrintLog,
  deleteBadgePrintLog,
  updateUserConnection,
  getLocalPrinterList,
  printLocal,
  addPrinter,
  deletePrinter,
  updateUserPrinterPreference,
  getBadgePrintLogDocument,
  deleteAllBadgePrintLog,
  getBadgeLogsReport,
  getBadgeLogsDetailCsv,
  geKioskModeDetails,
  updateKioskModeDetails,
  exitKioskMode
};

async function printLocal(datas) {
  try {
    const response = await axios.post("http://localhost:3000/upload-file", datas);
    return response.data;
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.error ?? "Unable to upload file"
    );
  }
}
async function getLocalPrinterList(){
  let {data}=await axios.get("http://localhost:3000/printers");
  return data;
}
async function checkUser(email) {
    return await axiosInstance.post(`/checkuser`, { email });
  
}
async function loginUser(email, password) {
    return await axiosInstance.post(`/login`, { email, password });
}
async function registerUser(data) {
    return await axiosInstance.put(`/register`, data);
  
}
async function getSauceToken(connectionId) {
    return await axiosInstance.post(`/ticket/get-access-token`, { connectionId });
  
}
async function getEventList(accessToken) {
    return await axiosInstance.get(`/ticket/get-events`, { accessToken });
  
}
async function forgotPassword(email) {
  return await axiosInstance.post(`/forget-password`, { email });
 
}
async function changeUserPassword(formdata) {
    return await axiosInstance.put(`/change-user-password`, formdata);
}
async function saveUserPreference(eventId, ticketId, design) {
  try {
    return await axiosInstance.post(
      `/save-user-preference/events/${eventId}/ticketId/${ticketId}`,
      design
    );
  } catch (error) {
    return null;
  }
}
async function createEventBadge(data) {
    return await axiosInstance.post(
      `/ticket/create-event-badge`,
      data
    );
}
async function getZlpImage(data){
    return await axiosInstance.post(
      `/image-to-zpl`,data,{
        headers:{
         "Content-Type": "multipart/form-data",
        }
      });
}
async function geEventBadge(eventId) {
  try {
    return await axiosInstance.get(
      `/ticket/event-badge/${eventId}`);
  } catch (error) {
    return null;
  }
}
async function getEventQuestions(eventId){
    return await axiosInstance.get(`/ticket/get-event-questions/${eventId}`);
   
}
async function getTicketQuestions(ticketId){
  return  await axiosInstance.get(`/ticket/get-ticket-question/${ticketId}`);
}
async function getOrders(eventId, data) {
    try {
      return await axiosInstance.get(`/ticket/get-orders/${eventId}`, { data });
    } catch (error) {
      return null;
    }
  
}

async function generateQrCode(ticketId, data) {
  try {
    return await axiosInstance.post(
      `/generate-dynamic-qr/ticketId/${ticketId}`,
      data
    );
  } catch (error) {
    return null;
  }
  //orderid 
}
async function getPreference(OrderId) {
    return await axiosInstance.post(`/get-user-preference`, { OrderId });
  
}
async function getUserData(id) {
    return await axiosInstance.get(`/get-user-ticket-data/${id}`);
 
}
async function getTicketDetail(id,eventId){
 try {
  return await axiosInstance.get(`/ticket/${id}?eventId=${eventId}`);
 } catch (error) {
   return {error:error?.response?.data?.message??"Ticket not found"};
 }
}
async function getOrderDetail(id,eventId){
  try {
    return await  axiosInstance.get(`/ticket/get-order-details/${id}?eventId=${eventId}`);
  } catch (error) {
    toast.error(error?.response?.data?.message??"Order not found")
    return null;
  }
  
}
async function getSearch(queries) {
  let query = queryString.stringify(queries);
    return await axiosInstance.get(
      `/order/search-attendee?`+query
    );
  
}

async function getPrintBadge(id) {
    return await axiosInstance.get(`/print-badge/${id}`);
}

async function sendZPLFileToPrint(formData, tenantId) {
    return await axiosInstance.post(`/v2/devices/printers/send`, formData, {
      isZebra: true,
      tenant: tenantId, // Dynamically set tenant ID
    });
}

async function fetchTenantId() {
    return await axiosInstance.get(`/v2/mytenant`, {
      isZebra: true
    });
  
}
async function getPrinterList(queries){
  let query = queryString.stringify(queries);
   return await axiosInstance.get("/printer/all-list?limit=20"+query);
}
async function addPrinter(obj){
  return await axiosInstance.post("/printer/add-printer",obj);
}
async function fetchPrinterList(){
  return await axiosInstance.post("/printer/");
}
async function deletePrinter(id){
  return await axiosInstance.delete(`/printer/${id}`);
}
async function updateDefaultPrinter(data){
  return await axiosInstance.put("/printer/",data);
}
async function updateUserPrinterPreference(data){
  return await axiosInstance.post("/printer/add-user-preference",data);
}
async function createBadgePrintLog(badgeDetails){
  return await axiosInstance.post("/badge-print-logs/",badgeDetails);
}
async function getBadgePrintLogDocument(id){
  return await axiosInstance.get(`/badge-print-logs/doc/${id}`);
}
async function getBadgeLogsReport(id){
  return await axiosInstance.get(`/badge-print-logs/event-log-csv/${id}`,{
    responseType: 'blob' 
  });
}
async function getBadgeLogsDetailCsv(id){
  try {
    return await axiosInstance.get(`/badge-print-logs/event-log-details-csv`,{
    responseType: 'blob' 
  });
  } catch (error) {
    return null;
  }
}

async function deleteAllBadgePrintLog(){
  return await axiosInstance.delete(`/badge-print-logs/all-logs/`);
}

async function getAllBadgePrintLog(queries){
  let query = queryString.stringify(queries);
  return await axiosInstance.get("/badge-print-logs/event-log-details?"+query);
}
async function deleteBadgePrintLog(id){
  return await axiosInstance.delete(`/badge-print-logs/${id}`);
}
async function updateUserConnection(data){
  return await axiosInstance.put(`/badge-print-logs/${data?.id}`,data);
}

async function geKioskModeDetails(eventId) {
  try {
    return await axiosInstance.get(
      `/kiosk-mode/${eventId}`);
  } catch (error) {
    return null;
  }
}

async function updateKioskModeDetails(data) {
  return await axiosInstance.put(
    `/kiosk-mode`, data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

async function exitKioskMode(data) {
    return await axiosInstance.post(
      `/kiosk-mode/exit`, data);
  
}



export default userService;
